import { createViewFilesList } from "@/modules/rev_eu/submissions/views/ViewFilesList";
import type { TViewFilesListParams } from "@/modules/rev_eu/submissions/views/ViewFilesList";
import type { TFileType } from "@/store";

/**
 * View parameters (injected dependencies)
 */
export type TViewFilesTBGLParams = TViewFilesListParams;

/**
 * View props (from router/parent)
 */
export type TViewFilesTBGLProps = Record<string, never>;

const TB_GL_FILE_TYPES: ReadonlySet<TFileType> = new Set<TFileType>(["tb", "gl", "otb", "tb_gl"]);

/**
 * Creates the TB/GL Files list view component (filtered to show only TB, GL, OTB files).
 */
export const createViewFilesTBGL = ({ useCases }: TViewFilesTBGLParams) =>
    createViewFilesList({
        title: "Financial TB/GL Files",
        description: "Trial Balance, General Ledger, and Opening Trial Balance files",
        errorTitle: "Failed to load files",
        emptyTitle: "No TB/GL files yet",
        emptyDescription:
            "Upload your first Trial Balance, General Ledger, or Opening Trial Balance file to get started.",
        availableFileTypes: TB_GL_FILE_TYPES,
    })({ useCases });
